import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EOtpremnicaPrevoz } from './eotpremnica-prevoz'

@Component({
  selector: 'yt-eotpremnica-prevoz-inline-update',
  templateUrl: './eotpremnica-prevoz-inline-update.component.html'
})
export class EOtpremnicaPrevozInlineUpdateComponent
 extends BaseInlineUpdateComponent<EOtpremnicaPrevoz> {
  constructor(protected inlineContainerService: InlineContainerService<EOtpremnicaPrevoz>){
    super(inlineContainerService);
  }

  // izlazna: boolean = false;
  //  ngAfterViewInit() {
  //     if (this.baseUpdateComponent.modelData)
  //       this.izlazna = this.baseUpdateComponent.modelData.MainList.FormControlDataName == "eotpremnice/izeotpremnicaprevoz";
  // }
}
